import { Box, useTheme } from "@mui/material";
import { FC } from "react";
import { ConfirmationDialog } from "../../../../components/ConfirmationDialog";
import { useLocalization } from "../../../../hooks/useLocalization";
import { FilterSelectOption, MENU_ITEM_HEIGHT } from "./FilterSelectOption";
import { FilterSelectOptionList } from "./FilterSelectOptionList";

interface FilterSelectMobileProps {
  isModalOpen: boolean;
  handleCancel: () => void;
  label: string;
  options: Array<{ value: string; label: string }>;
  isAllSelected: boolean;
  handleToggleAll: () => void;
  tempSelectedValues: string[];
  handleToggleOption: (value: string) => void;
  handleApply: () => void;
}

export const FilterSelectMobile: FC<FilterSelectMobileProps> = ({
  isModalOpen,
  handleCancel,
  label,
  options,
  isAllSelected,
  handleToggleAll,
  tempSelectedValues,
  handleToggleOption,
  handleApply,
}) => {
  const theme = useTheme();
  const { t } = useLocalization();

  return (
    <ConfirmationDialog.Root
      fullWidth
      maxWidth="xs"
      onClose={handleCancel}
      open={isModalOpen}
      sx={{
        "& .MuiDialog-paper": { padding: "16px", borderRadius: "24px" },
      }}
    >
      <ConfirmationDialog.Title showIcon={false} sx={{ padding: "0px" }}>
        {label}
      </ConfirmationDialog.Title>
      <ConfirmationDialog.Content sx={{ paddingX: "0px", mt: 2 }}>
        <Box>
          {options.length > 0 && (
            <Box>
              <FilterSelectOption
                isSelected={isAllSelected}
                label={t("components.filterSelect.all")}
                onClick={handleToggleAll}
                showBorder
              />
              <FilterSelectOptionList
                handleToggleOption={handleToggleOption}
                maxHeight={MENU_ITEM_HEIGHT * 12}
                options={options}
                tempSelectedValues={tempSelectedValues}
              />
            </Box>
          )}
        </Box>
      </ConfirmationDialog.Content>
      <ConfirmationDialog.Actions sx={{ padding: "0px" }}>
        <ConfirmationDialog.Button
          onClick={handleCancel}
          sx={{
            color: theme.colors.primary[5],
          }}
          variant="secondary"
        >
          {t("components.filterSelect.cancel")}
        </ConfirmationDialog.Button>
        <ConfirmationDialog.Button onClick={handleApply} variant="contained">
          {t("components.filterSelect.apply")}
        </ConfirmationDialog.Button>
      </ConfirmationDialog.Actions>
    </ConfirmationDialog.Root>
  );
};
